/**
 * Class strings for the plain labelled controls on the reservation and
 * amenity screens, in the create modals' idiom: hairline borders, the
 * semantic tokens, no raw zinc/gray. Literal strings on purpose —
 * Tailwind only generates classes it can see in the source.
 */
export const inputClass =
  'rounded-md border border-line bg-transparent px-2 py-1 text-[13px] text-fg ' +
  'placeholder:text-fg-faint focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent ' +
  '[color-scheme:light] dark:[color-scheme:dark] disabled:opacity-50';

export const invalidInputClass = 'border-danger';

export const labelClass = 'flex flex-col gap-1 text-[12px] font-medium text-fg-muted';

export const checkboxClass =
  'h-4 w-4 rounded border-line-strong bg-transparent text-accent focus:ring-accent disabled:opacity-50';

export const sectionTitleClass = 'text-[13px] font-semibold text-fg';

export const helpClass = 'text-[12px] text-fg-muted';
